import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tsu-home-services',
  templateUrl: './home-services.component.html',
  styleUrls: ['./home-services.component.scss']
})
export class HomeServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
